/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOrganizationsResponseMeta } from './ListOrganizationsResponseMeta';
import {
    ListOrganizationsResponseMetaFromJSON,
    ListOrganizationsResponseMetaFromJSONTyped,
    ListOrganizationsResponseMetaToJSON,
    ListOrganizationsResponseMetaToJSONTyped,
} from './ListOrganizationsResponseMeta';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
    ContactToJSONTyped,
} from './Contact';

/**
 * 
 * @export
 * @interface ListContactsResponse
 */
export interface ListContactsResponse {
    /**
     * 
     * @type {Array<Contact>}
     * @memberof ListContactsResponse
     */
    contacts: Array<Contact>;
    /**
     * 
     * @type {ListOrganizationsResponseMeta}
     * @memberof ListContactsResponse
     */
    meta: ListOrganizationsResponseMeta;
}

/**
 * Check if a given object implements the ListContactsResponse interface.
 */
export function instanceOfListContactsResponse(value: object): value is ListContactsResponse {
    if (!('contacts' in value) || value['contacts'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListContactsResponseFromJSON(json: any): ListContactsResponse {
    return ListContactsResponseFromJSONTyped(json, false);
}

export function ListContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListContactsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contacts': ((json['contacts'] as Array<any>).map(ContactFromJSON)),
        'meta': ListOrganizationsResponseMetaFromJSON(json['meta']),
    };
}

export function ListContactsResponseToJSON(json: any): ListContactsResponse {
    return ListContactsResponseToJSONTyped(json, false);
}

export function ListContactsResponseToJSONTyped(value?: ListContactsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contacts': ((value['contacts'] as Array<any>).map(ContactToJSON)),
        'meta': ListOrganizationsResponseMetaToJSON(value['meta']),
    };
}

